@if (isLokaleOmgeving) {
  <div class="debug-form alert" [class.alert-success]="form.valid" [class.alert-danger]="!form.valid">
    @if (raw) {
      <pre class="mb-0">{{ form.getRawValue() | json }}</pre>
    }
    @if (!raw) {
      <pre class="mb-0">{{ form.value | json }}</pre>
    }
    <div class="debug-form__icon" [class.debug-form__icon--success]="form.valid" [class.debug-form__icon--danger]="!form.valid">
      <fa-icon [icon]="['fas', form.valid ? 'check' : 'times']"></fa-icon>
    </div>
  </div>
}
